interface Refetchable {
  refetch: () => unknown;
}

/**
 * The portal's RETRY: ask again about what there is to ask about (#229).
 *
 * TanStack's `refetch` ignores `enabled`, so refetching the player query with no player id — a sign-in holding no
 * card, or staff who have browsed nobody — sent `GET /api/players/` with an empty id. It answered 405, and that
 * failure kept the portal on the error card after `/api/me` had recovered. Only a reload got out.
 */
export function refetchPortal(
  queries: { me: Refetchable; rooms: Refetchable; player: Refetchable },
  playerId: string | null,
): void {
  void queries.me.refetch();
  void queries.rooms.refetch();
  if (playerId !== null) void queries.player.refetch();
}
